import "../assets/useImageStyles.css";
import { h as $, defineComponent as k, ref as s, watchEffect as M, openBlock as b, createElementBlock as x, createBlock as C, unref as A, createCommentVNode as I, computed as d } from "vue";
import { p as W } from "./widgets-core.es.DdX21Kyh.js";
import { o as w } from "./useStore.DvPy8fc7.js";
import { g as D } from "./Text.vue_vue_type_style_index_0_lang.BEQZVGlu.js";
import { D as h } from "./maps.ChaVcqWI.js";
const U = (e, m) => {
  const a = "http://www.w3.org/2000/svg", i = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5 3.25A1.75 1.75 0 003.25 5v6.523l2.886-2.887.01-.01c.5-.48 1.11-.767 1.77-.767.66 0 1.271.287 1.77.767l.011.01 1.97 1.97.303-.303.01-.01c.5-.48 1.11-.768 1.77-.768.66 0 1.27.287 1.77.768l.01.01 1.22 1.22V5A1.75 1.75 0 0015 3.25H5zm11.75 10.394l-2.275-2.275c-.272-.26-.523-.344-.725-.344-.202 0-.453.084-.725.344l-.298.298 1.137 1.136a.75.75 0 01-1.061 1.06l-1.666-1.665-.001-.002-2.494-2.493c-.272-.26-.523-.344-.725-.344-.202 0-.453.083-.726.344L3.25 13.644V15A1.75 1.75 0 005 16.75h10A1.75 1.75 0 0016.75 15v-1.356zM1.75 15A3.25 3.25 0 005 18.25h10A3.25 3.25 0 0018.25 15V5A3.25 3.25 0 0015 1.75H5A3.25 3.25 0 001.75 5v10zm10-8.333a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const r = document.createElementNS(a, "title");
    r.textContent = e.title, i.appendChild(r);
  }
  const o = Array.from((i == null ? void 0 : i.attributes) ?? []).reduce((r, c) => ({
    ...r,
    [c.name]: c.value
  }));
  return $(
    "svg",
    {
      ...o,
      ...m.attrs,
      role: "img",
      innerHTML: i.innerHTML
    }
  );
}, B = ["data-module-id", "data-no-image"], S = ["data-image-loaded", "src", "alt"], F = /* @__PURE__ */ k({
  __name: "ImageWithBehaviour",
  props: {
    moduleProps: {},
    maxWidth: {},
    maxHeight: {}
  },
  emits: ["naturalImageHeight"],
  setup(e, { emit: m }) {
    const { t: a } = W(), l = e, i = s(), o = s(), r = s(), c = s(l.maxWidth), p = s(l.maxHeight), t = s(!1), v = s(!1), f = s(1), u = w(), P = m;
    function _() {
      if (i.value) {
        const {
          naturalWidth: n,
          naturalHeight: g
        } = i.value;
        f.value = n / g, t.value = !0, P("naturalImageHeight", g);
      }
    }
    function H(n) {
      t.value = !1, v.value = !0;
      const g = new Image();
      g.onload = () => {
        o.value = n, g.remove();
      }, g.onerror = () => {
        o.value = null, g.remove();
      }, g.src = n;
    }
    M(() => {
      if (l.moduleProps.image) {
        const n = u == null ? void 0 : u.literals.getLocaleImageUrl(l.moduleProps.image);
        n && n !== o.value && H(n), r.value = u == null ? void 0 : u.literals.getLocaleImageUrl(l.moduleProps.image);
      }
    }), M(() => {
      const n = l.moduleProps.maxWidth ? Math.min(l.moduleProps.maxWidth, l.maxWidth) : l.maxWidth;
      p.value = Math.min(l.maxHeight, n / f.value), c.value = p.value * f.value;
    });
    function L() {
      const n = D(l.moduleProps.behaviour.type);
      u == null || u.handlers.callHandler(n, l.moduleProps.id);
    }
    return (n, g) => (b(), x("div", {
      class: "thn--tool-image-with-behaviour",
      "data-module-id": l.moduleProps.id,
      "data-no-image": !o.value && !v.value,
      onClick: L
    }, [
      !o.value && !v.value ? (b(), C(A(U), {
        key: 0,
        class: "thn--tool-image-with-behaviour__icon",
        alt: A(a)("Picture icon")
      }, null, 8, ["alt"])) : I("", !0),
      o.value ? (b(), x("img", {
        key: 1,
        class: "thn--tool-image-with-behaviour__image",
        ref_key: "imageDom",
        ref: i,
        "data-image-loaded": t.value,
        src: o.value,
        alt: r.value,
        onLoad: _
      }, null, 40, S)) : I("", !0)
    ], 8, B));
  }
});
function K(e, m) {
  const a = w(), l = d(() => {
    var t;
    return (t = e.value) != null && t.image ? a == null ? void 0 : a.literals.getLocaleImageUrl(e.value.image) : "";
  }), i = d(() => {
    var t;
    return (t = e.value) != null && t.imageMobile ? a == null ? void 0 : a.literals.getLocaleImageUrl(e.value.imageMobile) : "";
  }), o = d(() => {
    var t;
    return (t = e.value) != null && t.image ? a == null ? void 0 : a.literals.getLocaleImageAlt(e.value.image) : "";
  }), r = d(() => {
    var t;
    return (t = e.value) != null && t.imageMobile ? a == null ? void 0 : a.literals.getLocaleImageAlt(e.value.imageMobile) : "";
  }), c = d(() => e.value.sync === !1 ? m.value === h.Mobile ? i.value : l.value : m.value === h.Mobile && i.value ? i.value : l.value), p = d(() => e.value.sync === !1 ? m.value === h.Mobile ? r.value : o.value : m.value === h.Mobile && i.value ? r.value : o.value);
  return {
    imageUrl: c,
    imageAlt: p
  };
}
const O = (e, m, a = s("left")) => ({
  imageStyles: d(() => {
    var f, u;
    if (m.value === h.Desktop && !((f = e.value) != null && f.imagePadding) || m.value === h.Mobile && !((u = e.value) != null && u.imageMobilePadding)) return "";
    const i = m.value === h.Mobile ? e.value.imageMobilePadding : e.value.imagePadding;
    if (!i) return "";
    const {
      top: o,
      bottom: r,
      left: c,
      right: p,
      format: t
    } = i, v = {
      top: `${o}${t}`,
      bottom: a.value !== "top" ? `${r}${t}` : "0px",
      right: a.value !== "left" ? `${p}${t}` : "0px",
      left: a.value !== "right" ? `${c}${t}` : "0px"
    };
    return `
      padding: ${v.top} ${v.right} ${v.bottom} ${v.left};
    `;
  })
});
export {
  F as _,
  O as a,
  U as i,
  K as u
};
//# sourceMappingURL=useImageStyles.byYJo1RL.js.map
